import React from 'react';

export default function(props) {
  return (
    <svg height="22" width="22" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.895 10.123v7.018a1.76 1.76 0 0 1-1.754 1.754H4.859a1.76 1.76 0 0 1-1.754-1.754V4.859c0-.964.79-1.754 1.754-1.754h7.018v.878H4.86a.882.882 0 0 0-.876.876v12.282c0 .48.396.876.876.876h12.282c.48 0 .876-.396.876-.876v-7.018zM7.344 8.918l3.602 3.202 6.73-8.412a.439.439 0 0 1 .684.549l-7.306 9.132-4.293-3.816a.44.44 0 0 1 .583-.655z" />
    </svg>
  );
}
